import React, { useMemo, useState } from "react";
import styled from "styled-components"
import { LuChevronLeft, LuChevronRight } from "react-icons/lu";
import LogoCenter from "../components/LogoCenter"
import { Apis } from "../util/Apis"
import ContainerBackgroundWrapper from "../components/Backgrounds"
import AnforaDetails from "../components/AnforaDetails"
import CustomLoading from "../components/CustomLoading"
import { getFirstLetters, labelOfPagina } from "../util";
import useGet from "../hooks/useGet";

const ContainerAnfora = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: calc(65vh - 1rem);
`

const ContainerAnforaLeft = styled.div`
  width: 40%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.5s ease;
`

const ContainerAnforaRight = styled.div`
  width: 60%;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
`

// Tabla y paginación con las medidas que tenían la Table y TablePagination de Material UI.
const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  td {
    padding: 16px;
    border-bottom: 1px solid rgba(224, 224, 224, 1);
    text-align: center;
    font-size: 1.5rem;
    color: white;
  }
`

const TableFooterCustom = styled.tfoot`
  background: ${(props) => props.theme.tableHead};
  border-radius: 5px 5px 0 0;
  box-shadow: rgb(0 0 0 / 50%) 0 0 10px 5px;
  color: white;
`

const TableRowCustom = styled.tr`
  &:nth-of-type(odd) {
    background-color: ${(props) => props.theme.tableItem};
  }

  &:nth-of-type(even) {
    background-color: rgb(255 255 255 / 4%);
  }
`

const Pagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
  min-height: 52px;
  padding: 0 2px;
  font-size: 0.875rem;
  select {
    margin-left: 8px;
    border: 0;
    background: transparent;
    color: inherit;
    font: inherit;
  }
  option {
    color: black;
  }
  button {
    display: inline-flex;
    padding: 12px;
    border: 0;
    border-radius: 50%;
    background: transparent;
    color: inherit;
    cursor: pointer;
  }
  button:disabled {
    opacity: 0.38;
    cursor: default;
  }
`
const ultimosParticipantes = [
  {
    id: 1,
    name: "José Carlos",
    lastName: "Medina",
    quantity: 530
  },
  {
    id: 2,
    name: "Andres",
    lastName: "L",
    quantity: 200
  },
  {
    id: 3,
    name: "Eder",
    lastName: "Q",
    quantity: 120
  }
]


const AnforaView = () => {

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const anforaId = localStorage.getItem('anforaId')

  const { loading, data } = useGet({
    url: Apis.PC + '/anforas/' + anforaId,
    initialValue: [],
  })

  const couponType = useGet({
    url: `${Apis.PC}/coupon-type`,
  })

  const emptyRows = useMemo(() => rowsPerPage - Math.min(rowsPerPage, ultimosParticipantes.length - page * rowsPerPage), [rowsPerPage, page]);

  const total = ultimosParticipantes.length;
  const firstRow = page * rowsPerPage + 1;
  const lastRow = Math.min((page + 1) * rowsPerPage, total);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <ContainerBackgroundWrapper>
      {!loading ?
        <>
          <LogoCenter />
          <ContainerAnfora>
            <ContainerAnforaLeft>
              <AnforaDetails name={data?.name} quantity={!loading ? data.currentQuantity : ' '}
                couponId={data?.couponTypeId} couponTypeData={!couponType.loading && couponType.data}
              />
            </ContainerAnforaLeft>
            <ContainerAnforaRight>
              <p style={{ fontSize: "2rem", fontWeight: "bold", margin: "1rem" }}>Últimos Participantes</p>
              <div style={{
                width: "90%",
                maxHeight: "calc(100vh - 340px)",
                overflowY: "auto",
                boxShadow: "rgb(0 0 0 / 50%) 0px 0px 10px 5px"
              }} className='custom-scroll'>
                <Table>
                  <TableFooterCustom>
                    <tr>
                      <td colSpan={4} style={{ padding: 0 }}>
                        <Pagination>
                          <label>
                            Participantes por página
                            <select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
                              {[5, 10].map((option) => <option key={option} value={option}>{option}</option>)}
                            </select>
                          </label>
                          <span>{labelOfPagina(firstRow, lastRow, total)}</span>
                          <span>
                            <button type="button" aria-label="Página anterior" disabled={page === 0} onClick={() => setPage(page - 1)}>
                              <LuChevronLeft size={24} aria-hidden="true" />
                            </button>
                            <button type="button" aria-label="Página siguiente" disabled={lastRow >= total} onClick={() => setPage(page + 1)}>
                              <LuChevronRight size={24} aria-hidden="true" />
                            </button>
                          </span>
                        </Pagination>
                      </td>
                    </tr>
                  </TableFooterCustom>
                  <tbody>
                    {(rowsPerPage > 0
                      ? ultimosParticipantes.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      : ultimosParticipantes).map((participante) => (
                        <TableRowCustom key={participante.name}>
                          <td>{participante.id}</td>
                          <td>{getFirstLetters(participante.name, participante.lastName)}</td>
                          <td>{participante.quantity}</td>
                        </TableRowCustom>
                      ))}
                    {emptyRows > 0 && (
                      <tr style={{ height: 66 * emptyRows }}>
                        <td colSpan={6} />
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </ContainerAnforaRight>
          </ContainerAnfora>
        </>
        :
        <CustomLoading />
      }
    </ContainerBackgroundWrapper>
  )
}

export default AnforaView;
